import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {CompletionEstimate} from "@app/shared/completion-estimate/completion-estimate";
import {QueryResult} from "@app/shared";

@Injectable()
export class CompletionEstimateService {

  constructor(private http: HttpClient) { }

  searchEstimatedCompletions(contractId?: number, clinId?: number, projectId?: number): Observable<QueryResult> {
    let url = `/completion-estimates/search?`;
    if (contractId) {
      url += `&contract.id=${contractId}`;
    }
    if (clinId) {
      url += `&clin.id=${clinId}`;
    }
    if (projectId) {
      url += `&project.id=${projectId}`;
    }
    return this.http.get<QueryResult>(url);
  }

  saveOrUpdateEstimatedCompletion(estimatedCompletion: CompletionEstimate): Observable<CompletionEstimate> {
    let url = `/completion-estimates`;
    if (estimatedCompletion.id) {
      url += `/${estimatedCompletion.id}`;
      return this.http.put<CompletionEstimate>(url, estimatedCompletion);
    } else {
      return this.http.post<CompletionEstimate>(url, estimatedCompletion);
    }
  }
}
